<template>
    <div class="nav-control">
        <a v-popover:goldenQuestions class="btn green arrow-bottom">Golden Questions</a>
        <transition name="show-from-bottom">
            <popover name="goldenQuestions" :width=500>
                <p v-for="(question, index) in goldenQuestions" :key="index">{{ question }}</p>
            </popover>
        </transition>
    </div>
</template>

<script>

import Vue from 'vue';
import Popover from 'vue-js-popover';

Vue.use(Popover);

export default {
  name: 'NavControl',
  props: ['route'],
  data() {
    return {
      goldenQuestions: [
        'Which car do you drive now?',
        'What do you lie / dislike about your car?',
        'What do you expect from your car?',
        'Life circumstances (e.g. private or commercial customer)',
        'Marital and family status (e.g. housing situation, children)',
        'Current vehicle (e.g first or second vehicle)',
        'Primary user (e.g. are the user and potential customer identical)',
        'Use and mileage (e.g. priavte-business use)',
        'Personality of the driver (e.g comfort-oriented, status-oriented)',
        'Use requirement (e.g. customer preferences, technology)',
        'Space and transport required',
        'Time of purchase (buying decision, desired delivery time)',
        'Budget and financing (e.g. cash payment, financing, leasing)',
        'Summarize & confirm needs',
      ],
    };
  },
  methods: {
    redirectTo() {
      if (this.route) {
        this.$router.go(-1);
      } else {
        this.$router.go(this.$router.currentRoute);
      }
    },
  },
};
</script>
